import {
  Button, message, Modal, Pagination, Space, Table,
} from 'antd';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import translations from '../../../hooks/translation/translations.json';
import useTranslation from '../../../hooks/translation/useTranslation';

function Countries() {
  const { trans } = useTranslation();
  const [countries, setCountries] = useState();
  const [render, setRender] = useState();
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  const columns = [
    {
      title: trans('country_flag'),
      dataIndex: 'flag_image_path',
      key: 'flag_image_path',
    },
    {
      title: trans('country_name_geo'),
      dataIndex: 'name_ka',
      key: 'name_ka',
    },
    {
      title: trans('country_name_en'),
      dataIndex: 'name_en',
      key: 'name_en',
    },
    {
      title: trans('country_name_ru'),
      dataIndex: 'name_ru',
      key: 'name_ru',
    },
    {
      title: trans('country_phone_code'),
      dataIndex: 'country_phone_code',
      key: 'country_phone_code',
    },
    {
      title: trans('edit'),
      dataIndex: 'edit',
      key: 'edit',
    },
    {
      title: trans('delete'),
      dataIndex: 'delete',
      key: 'delete',
    },
  ];

  useEffect(() => {
    axios.get('/api/countries', { params: { page } }).then((res) => {
      if (res.data?.status === 'success') {
        setCountries(res?.data.countries);
      }
    });
  }, [!render, page]);

  const deleteCountry = (id) => {
    message
      .loading(
        translations.ka.country_delete_in_progress,
        axios.delete(`/api/countries/${id}`).then((res) => {
          if (res?.data.status === 'success') {
            setRender(!render);
          }
        }),
      )
      .then(
        () => setTimeout(() => message.success(translations.ka.country_successfully_deleted), 400),
      );
  };

  const checkIfDelete = (id, name) => {
    Modal.confirm({
      title: translations.ka.delete_country,
      content: `თქვენ ნამდვილად გსურთ, რომ ${name} წაშალოთ?`,
      okText: translations.ka.yes,
      onOk: () => deleteCountry(id),
      cancelText: translations.ka.no,
    });
  };

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <Button type="primary" onClick={() => navigate('/admin/countries/add')}>{trans('add_country')}</Button>
      <div style={{ overflowX: 'auto' }}>
        <Table
          pagination={false}
          dataSource={countries?.data?.map((country) => ({
            key: country.id,
            flag_image_path: <img src={`/${country?.flag_image_path}`} width={50} height={50} style={{ objectFit: 'contain' }} alt={country?.name_ka} />,
            name_ka: country?.name_ka,
            name_en: country?.name_en,
            name_ru: country?.name_ru,
            country_phone_code: country?.country_phone_code,
            edit: <Button onClick={() => navigate(`/admin/countries/${country?.id}/edit`)}>{trans('edit')}</Button>,
            delete: (
              <Button
                type="danger"
                onClick={() => checkIfDelete(country?.id, country?.name_ka)}
              >
                {trans('delete')}
              </Button>
            ),
          }))}
          columns={columns}
        />
      </div>
      {countries
      && (
      <Pagination
        pageSize={countries?.meta?.itemsPerPage}
        total={countries?.meta?.totalItems}
        current={page}
        onChange={(e) => setPage(e)}
      />
      )}
    </Space>
  );
}

export default Countries;
